import debug from 'debug';

export const log = debug('editor');

export default log;
